module.exports = __webpack_public_path__ + "db4a7967d98367ddbfec7c25c6c1f37e.svg";